export const OPEN_MODAL_UPLOAD_IMAGE = "OPEN_MODAL_UPLOAD_IMAGE"
// export const ADD_IMAGE_PATH = "ADD_IMAGE_PATH"
export const ADD_IMAGE_BASE64 = "ADD_IMAGE_BASE64"

export function dispatchModalUploadImage (params) {
    return {
        type: params.type,
        payload: params.payload
    }
}